export enum ListManipulationAction{
    ADD = "Add",
    REMOVE = "Remove",
    SHUFFLE = "Shuffle",
    CLEAR = "Clear"
} 